import { camelCase } from 'camel-case';
import type { CamelCase } from 'type-fest';
import { type TrackEventProperties, useAnalytics } from '../context';
import { TrackEventNames } from '../types';

type DemoEventPayload = Pick<
  TrackEventProperties,
  | 'demoId'
  | 'demoName'
  | 'demoType'
  | 'forClient'
  | 'variables'
  | 'resolution'
  | 'period'
>;
type EventName = keyof typeof TrackEventNames;
type FunctionName =
  `track${Capitalize<CamelCase<keyof typeof TrackEventNames>>}`;
const functionNameEntries = Object.keys(TrackEventNames).map((eventName) => [
  eventName as EventName,
  `track${eventName[0].toUpperCase()}${camelCase(eventName.slice(1))}` as FunctionName,
]);

export const useDemoAnalytics = (location: string) => {
  const { trackEvent } = useAnalytics();

  return Object.fromEntries(
    functionNameEntries.map(([eventName, functionName]) => [
      functionName,
      (payload?: DemoEventPayload) => {
        trackEvent(TrackEventNames[eventName], {
          ...payload,
          location,
        });
      },
    ])
  ) as {
    [K in FunctionName]: (payload?: DemoEventPayload) => void;
  };
};
